// colors.js
export const Colors = {
  // Main Palette
  background: {
    light: "#FDF8F1",  // SwiftUI light: 253,248,241
    dark: "#141414",   // SwiftUI dark: 20,20,20
  },
  accent: {
    light: "#ECE7D4",  // 236,231,212
    dark: "#32322D",   // 50,50,45
  },
  primary: {
    light: "#FEF3E1",  // 254,243,225
    dark: "#FEF3E1",   // same as light
  },
  secondary: {
    light: "#FCDCBA",  // 252,220,186
    dark: "#64503C",   // 100,80,60
  },
  important: {
    light: "#D66B66",  // 214,107,102
    dark: "#D66B66",
  },
  darkText: {
    light: "#86531D",  // 134,83,29
    dark: "#F0DCC8",   // 240,220,200
  },

  // Element Colors
  firePrimary: "#FEDCA2",   // 254,220,162
  fireSecondary: "#FFB76B", // 255,183,107

  airPrimary: "#D2BEB9",    // 210,190,185
  airSecondary: "#B4A5A0",  // 180,165,160

  waterPrimary: "#ADD8E6",  // 173,216,230
  waterSecondary: "#C6EAFA",// 198,234,250

  earthPrimary: "#EEE5BD",  // 238,229,189
  earthSecondary: "#BEB496",// 190,180,150

  buttonImportantPrimary: {
    light: "#FEB78C",  // 254,183,140
    dark: "#D2825A",   // 210,130,90
  },
  buttonImportantSecondary: {
    light: "#F4A086",  // 244,160,134
    dark: "#B46E5A",   // 180,110,90
  },

  icon: {
    light: "#C5AFC9",  // 197,175,201
    dark: "#A88BAE",   // 168,139,174
  },
};

// Helper to get current mode color
export const getColor = (colorObj) => {
  if (typeof window !== "undefined" && window.matchMedia) {
    const isDark = window.matchMedia("(prefers-color-scheme: dark)").matches;
    return isDark ? colorObj.dark ?? colorObj.light : colorObj.light ?? colorObj.light;
  }
  return colorObj.light ?? "#000";
};
